import React, { useState } from "react";
import {
  DialogContent,
  CardContent,
  Card,
  Button,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  FormControl,
} from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Spin from "components/ui/Spin";
import InputField from "components/ui/form/InputField";
import {
  addConfiguration,
  updateConfiguration,
} from "shared/api/configurations";
import { toastError, toastSuccess } from "shared/utils";
import Select from "react-select";
import ConfirmPassword from "pages/Configurations/confirmPassword";

const ErrorText = (props) => (
  <span
    style={{
      width: "100%",
      marginTop: "0.25rem",
      fontSize: "80%",
      color: "#ff3d60",
    }}
  >
    {props.text}
  </span>
);

export const AddPlebgraphConfiguration = (props) => {
  const { visible, callbackEvent, data, isEditing } = props;
  const [FieldValues, setFieldValues] = useState(props?.data?.meta_data_type);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [updateConfigParam, setUpdateConfigParam] = useState({});

  const handleClose = (_) => {
    callbackEvent(false);
  };

  let data_type = [
    { value: "integer", label: "INTEGER" },
    { value: "string", label: "STRING" },
    { value: "float", label: "FLOAT" },
    { value: "boolean", label: "BOOLEAN" },
    { value: "array", label: "ARRAY" },
    { value: "json", label: "JSON" },
  ];

  let error_status = (fieldValues) => {
    const reg_integer = /^\d+$/;
    const reg_float = /^[+-]?\d+\.\d+$/;
    const reg_boolean = /^([Tt][Rr][Uu][Ee]|[Ff][Aa][Ll][Ss][Ee])$/;
    switch (fieldValues) {
      case "integer":
        return Yup.string().matches(reg_integer, "Please enter int value!");
      case "string":
        return Yup.string().required("Please enter string value!");
      case "float":
        return Yup.string().matches(reg_float, "Please enter float value!");
      case "boolean":
        return Yup.string().matches(reg_boolean, "Please enter boolean value!");
      case "array":
        return Yup.string().required("Please enter array value!");
      case "json":
        return Yup.string().required("Please enter json value!");
      default:
        return;
    }
  };

  const scheme = Yup.object().shape({
    title: Yup.string().required("Please enter title"),
    meta_key: Yup.string().required("Please enter meta key!"),
    meta_data_type: Yup.string().required("Please select meta data type"),
    status: Yup.string().required("Please select status!"),
    description: Yup.string().required("Please enter description"),
    meta_value: error_status(FieldValues),
  });
  const handleSubmit = async (values) => {
    if (values.meta_data_type === "json") {
      try {
        const parsed_json_data = JSON.parse(values.meta_value);
        if (
          typeof parsed_json_data !== "object" ||
          Array.isArray(parsed_json_data)
        ) {
          throw new toastError("Invalid JSON data");
        }
      } catch (error) {
        toastError("Invalid JSON Data");
        return;
      }
    } else if (values.meta_data_type === "array") {
      try {
        const meta_array_data = JSON.parse(values.meta_value);
        if (!Array.isArray(meta_array_data)) {
          throw new toastError("Invalid array data");
        }
      } catch (error) {
        toastError("Invalid array data");
        return;
      }
    }
    let param = {
      ...values,
      merchant_reference_number: "MERT1867685187882O9R",
    };
    let response = null;
    if (isEditing) {
      let id = data.id;
      setOpenPasswordModal(true);
      setUpdateConfigParam({ param, id });
      // response = await updateConfiguration(param, id);
    } else {
      response = await addConfiguration(param);
    }
    if (response && response.success) {
      const { meta_key } = response.data;
      toastSuccess(`${meta_key} have added successfully`);
      callbackEvent(true);
    } else {
      toastError(response.message);
    }
  };

  const onCloseConfirmModal = () => {
    setOpenPasswordModal(false);
    setUpdateConfigParam(null);
  };

  const onPasswordConfirm = async (password) => {
    if (!updateConfigParam) return;
    const encodedPassword = btoa(password);


    const updatedParam = {
      ...updateConfigParam.param,
      config_password:encodedPassword,
    };
    try {
      const response = await updateConfiguration(
        updatedParam,
        updateConfigParam?.id
      );
      if (response && response.success) {
        toastSuccess(`Updated successfully`);
        callbackEvent(true);
      } else {
        toastError(response.message);
      }
    } catch (error) {
      toastError("Something went wrong");
    } finally {
      setOpenPasswordModal(false);
      setUpdateConfigParam(null);
    }
  };

  return (
    <Spin>
      <KisshtDialog
        title={
          data
            ? isEditing && "Edit Plebgraph Configuration"
            : "Add Plebgraph Configuration"
        }
        maxWidth={data ? isEditing && "md" : "sm"}
        open={visible}
        handleClose={handleClose}
      >
        <DialogContent>
          <Card>
            <CardContent>
              <Formik
                initialValues={{
                  title: data ? data.title : "",
                  meta_key: data ? data.meta_key : "",
                  meta_value: data ? data.meta_value : "",
                  meta_data_type:
                    data && isEditing && data?.meta_data_type
                      ? data.meta_data_type
                      : "",
                  description: data?.description ? data?.description : "",
                  status: data ? data.status : "ACTIVE",
                }}
                validationSchema={scheme}
                onSubmit={handleSubmit}
              >
                {({
                  isValid,
                  isSubmitting,
                  values,
                  touched,
                  setFieldValue,
                  handleChange,
                  errors,
                }) => (
                  <Spin spinning={isSubmitting}>
                    <Form style={{ textAlign: "-webkit-center" }}>
                      <Field
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="title"
                        required
                        label="Title"
                        placeholder="Please enter title"
                        name="title"
                        component={InputField}
                        touched={touched}
                        onChange={handleChange}
                        value={values.title}
                      />
                      {!isEditing ? (
                        <Field
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          required
                          id="meta_key"
                          label="Meta Key"
                          placeholder="Please enter Meta Key"
                          name="meta_key"
                          component={InputField}
                          touched={touched}
                          value={values.meta_key}
                        />
                      ) : (
                        <div className="my-4">
                          <Grid container spacing={4}>
                            <Grid item>
                              <FormLabel component="legend">
                                Meta Key :{" "}
                              </FormLabel>
                            </Grid>
                            <Grid item>
                              <FormLabel
                                component="legend"
                                style={{ color: "#000000" }}
                              >
                                {data && data.meta_key}
                              </FormLabel>
                            </Grid>
                          </Grid>
                        </div>
                      )}
                      <Select
                        label="meta_data_type"
                        placeholder="Select Meta Data Type"
                        onChange={(selectedOption) => {
                          setFieldValue(
                            "meta_data_type",
                            selectedOption["value"]
                          );
                          setFieldValues(selectedOption["value"]);
                        }}
                        value={data_type.filter(
                          (datas) => datas.value === values.meta_data_type
                        )}
                        isSearchable={true}
                        options={data_type}
                        name="meta_data_type"
                        id="meta_data_type"
                        isLoading={false}
                        loadingMessage={() => "Fetching meta data type"}
                        noOptionsMessage={() => "No Options Available"}
                      />
                      {values?.meta_data_type === "" ? (
                        <ErrorText text={errors?.meta_data_type} />
                      ) : (
                        ""
                      )}
                      <Grid item>
                        {values.meta_data_type ? (
                          <Field
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            multiline={
                              values.meta_value && values.meta_value.length > 50
                                ? true
                                : false
                            }
                            required
                            id="meta_value"
                            label="Meta Value"
                            placeholder="Please enter Meta Value"
                            name="meta_value"
                            component={InputField}
                            touched={touched}
                            value={values.meta_value}
                          />
                        ) : (
                          ""
                        )}
                      </Grid>
                      <Field
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        required
                        id="description"
                        label="Description"
                        placeholder="Please enter description"
                        name="description"
                        component={InputField}
                        touched={touched}
                        value={values.description}
                      />
                      <FormControl
                        component="fieldset"
                        className="mt-2 ml-2"
                        fullWidth
                      >
                        <FormLabel component="legend">Status</FormLabel>
                        <RadioGroup
                          aria-label="status"
                          name="status"
                          row
                          value={values.status}
                          onChange={handleChange}
                          style={{ textAlign: "center" }}
                        >
                          <FormControlLabel
                            value="ACTIVE"
                            control={<Radio color="primary" />}
                            label="ACTIVE"
                          />
                          <FormControlLabel
                            value="INACTIVE"
                            control={<Radio color="primary" />}
                            label="INACTIVE"
                          />
                        </RadioGroup>
                      </FormControl>
                      <div style={{ textAlign: "center", marginTop: "50px" }}>
                        <Button
                          type="submit"
                          size="large"
                          variant="contained"
                          color="primary"
                          className="mt-4 justify-center common_kissht_btn"
                        >
                          Submit
                        </Button>
                      </div>
                    </Form>
                  </Spin>
                )}
              </Formik>
            </CardContent>
          </Card>
        </DialogContent>
      </KisshtDialog>
      <ConfirmPassword
        visible={openPasswordModal}
        handleClose={onCloseConfirmModal}
        handleConfirm={onPasswordConfirm}
      />
    </Spin>
  );
};

export default AddPlebgraphConfiguration;
